import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IUserRetractPointHistory {
    id: number
    type: string
    reason: string
    amount: number
    point_tx_id: number
    manager_id: string
    manager_name: string
    manager_thumbnail: string
    user_id: string
    user_name: string
    user_thumbnail: string
    created_at: number
}

export const getUserRetractPointHistory = async (limit, skip): Promise<ApiRes<IUserRetractPointHistory[]>> => {
    return await apiGet(API_URL, `admin/point/modification?limit=${limit}&skip=${skip}`)
}
